import isMobile from '../helpers/platform';

export const API_KEY = 'AIzaSyAiipzzHMPbUFCSdcvGNGZIms3SIXwlQkA';
export const MAP_CONFIG = {
  backgroundColor: '#F3F3F3',
  animatedZoom: false,
  zoomControl: false,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false,
  scrollwheel: false,
  minZoom: isMobile() ? 7 : 8,
  maxZoom: isMobile() ? 12 : 10,
  styles: [
    {
      featureType: 'all',
      stylers: [
        { visibility: 'off' },
      ],
    },
    {
      featureType: 'road',
      stylers: [
        { visibility: 'off' },
      ],
    },
  ],
};

export const MARKER_ICON = {
  path: 'M 0, 0 m -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0',
  strokeOpacity: 0.7,
  strokeWeight: 4,
  strokeColor: '#000000',
  fillColor: '#FF0000',
  fillOpacity: 0.7,
  scale: 1,
};
